import React from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from 'actions/index';
import { __ } from 'locale';

function ConfirmDialog({ message, onConfirm, confirmLabel, cancelLabel }) {
    const dispatch = useDispatch();
    return (
        <div className="p-[0.5em]">
            {message && <p>{message}</p>}
            <div className="flex items-center gap-[1.5em] mt-[0.75em]">
                <button
                    className="bg-[#26AA52] text-white py-[0.5em] px-[1em] rounded cursor-pointer border-none hover:bg-[#2dcb62]"
                    onClick={() => { dispatch(closeModal()); onConfirm(); }}
                >
                    {confirmLabel || __('Potvrdit')}
                </button>
                <a className="text-[#999] underline cursor-pointer" onClick={() => dispatch(closeModal())}>
                    {cancelLabel || __('Zpět')}
                </a>
            </div>
        </div>
    );
}

export default ConfirmDialog;
